import {GROWL_TYPE, showMessageGrowl} from '@Components/message-growl';
import type {PopupBlockedGrowl} from '@Libraries/open-design-in-new-tab.library.types';

/** Opens the design in a new tab; if the popup is blocked (no user activation after an await), a growl link opens it on click. */
export const openDesignInNewTab = (url: string, blockedGrowl: PopupBlockedGrowl): void => {
  if (window.open(url, '_blank')) {
    return;
  }

  showMessageGrowl({
    key: blockedGrowl.key,
    text: blockedGrowl.text,
    type: GROWL_TYPE.NEUTRAL,
    showCloseIcon: true,
    action: {label: blockedGrowl.actionLabel ?? window.i18next.t('pmwjs_open_design'), url, openInNewTab: true},
  });
};
